/* Homepage minimal navigation overlay and scroll-aware header. */
(function(){
  'use strict';
  var header=document.querySelector('[data-vj-stage-header]');
  if(!header)return;
  var toggle=header.querySelector('.vj-stage-header__toggle');
  var menu=header.querySelector('#vj-stage-navigation');
  if(!toggle||!menu)return;
  var priorFocus=null,priorOverflow='';
  var menuLinks=Array.prototype.slice.call(menu.querySelectorAll('a[href]'));
  function showScrolledHeader(){header.classList.toggle('is-scrolled',window.scrollY>Math.max(48,window.innerHeight*.35));}
  function closeMenu(){
    if(menu.hidden)return;
    header.classList.remove('is-open');
    menu.hidden=true;
    menu.setAttribute('aria-hidden','true');
    toggle.setAttribute('aria-expanded','false');
    toggle.setAttribute('aria-label','Open navigation menu');
    document.body.style.overflow=priorOverflow;
    document.removeEventListener('keydown',onKeydown);
    if(priorFocus&&priorFocus.focus)priorFocus.focus();
  }
  function onKeydown(e){
    if(e.key==='Escape'){e.preventDefault();closeMenu();return;}
    if(e.key==='Tab'){
      /* Keep keyboard focus inside the expanded navigation. */
      var focusables=[toggle].concat(menuLinks.filter(function(link){return link.getClientRects().length>0;}));
      var first=focusables[0],last=focusables[focusables.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }
  }
  function openMenu(){
    priorFocus=document.activeElement;
    priorOverflow=document.body.style.overflow;
    menu.hidden=false;
    menu.setAttribute('aria-hidden','false');
    toggle.setAttribute('aria-expanded','true');
    toggle.setAttribute('aria-label','Close navigation menu');
    header.classList.add('is-open');
    document.body.style.overflow='hidden';
    document.addEventListener('keydown',onKeydown);
    if(menuLinks.length)menuLinks[0].focus();
  }
  toggle.addEventListener('click',function(){if(menu.hidden)openMenu();else closeMenu();});
  menuLinks.forEach(function(link){link.addEventListener('click',closeMenu);});
  window.addEventListener('scroll',showScrolledHeader,{passive:true});
  showScrolledHeader();
})();
